/* eslint-disable no-console */
document.addEventListener("DOMContentLoaded", () => {
  const PRICE_VARIANTS = {
    dimensions: [
      { value: '3" X 20" Inches', price: 0 },
      { value: '4" X 24" Inches', price: 9 },
      { value: '6" X 36" Inches', price: 21 },
      { value: '8" X 48" Inches', price: 33 },
    ],
  };

  const state = {
    color_fill: "Gradient Color Fill",
    font: "Anton",
    decal_color: "Gloss Black",
    reg_number: null,
    dimensions: '6" X 36" Inches',
    price: 39.48,
  };

  const PCBD_CART_BTN_HTML = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.5"></circle><circle cx="18" cy="20" r="1.5"></circle><path d="M2 3h3l2.4 12.4a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.6L23 6H6"></path></svg> Add to cart`;
  const PCBD_CART_LOADING_HTML = `<span class="pcbd-cart-loading"><svg class="pcbd-cart-loading__icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-6.22-8.56"></path></svg>Adding to cart</span>`;

  const hide = (el) => {
    if (el) el.style.display = "none";
  };

  const getDecalColorList = () =>
    document.querySelector(
      "#decal-color-variant .pcbd-letter-colors, #decal-color-variant .letter-color-variants__list"
    );

  const getDecalColorSwatches = (root) =>
    root?.querySelectorAll(".pcbd-letter-swatch, .sticker-variant") || [];

  const getDimensionsRows = () =>
    document.querySelectorAll("#decal-length-select [data-dimensions-option]");

  function animatePriceChange(el, start, end, duration = 500) {
    let t0 = null;

    function step(ts) {
      if (!t0) t0 = ts;
      const p = Math.min((ts - t0) / duration, 1);
      el.textContent = (start + (end - start) * p).toFixed(2);
      if (p < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function priceOf(group, value) {
    const found = (PRICE_VARIANTS[group] || []).find((x) => x.value === value);
    return found ? found.price : 0;
  }

  function recalcPrice() {
    const base = 18.48;
    const total = base + priceOf("dimensions", state.dimensions);
    const priceEl = document.getElementById("pcs-final-price");
    const prev = parseFloat(priceEl?.textContent || "0") || 0;
    if (priceEl && prev !== total) animatePriceChange(priceEl, prev, total);
    state.price = total;
  }

  function setupColorFillSelection() {
    const wrap = document.getElementById("color-fill-variant");
    if (!wrap) return;

    wrap.addEventListener("click", (e) => {
      const card = e.target.closest(".sticker-variant");
      if (!card) return;
      wrap
        .querySelectorAll(".sticker-variant")
        .forEach((v) => v.classList.toggle("active", v === card));
      state.color_fill = card.dataset.fill;
    });
  }

  function initDropdownDefaults() {
    document.querySelectorAll(".select-dropdown").forEach((dd) => {
      const pre = dd.querySelector("li.selected");
      if (pre) dd.querySelector(".selected-text").textContent = pre.textContent;
    });
  }

  function syncDimensionsFallback(value) {
    const wrap = document.getElementById("decal-length-select");
    if (!wrap) return;

    wrap.querySelectorAll(".dropdown-options li").forEach((li) => {
      li.classList.toggle("selected", li.dataset.value === value);
    });

    const selectedText = wrap.querySelector(".selected-text");
    if (selectedText) selectedText.textContent = value;
  }

  function setupDecalSizeSelection() {
    const wrap = document.getElementById("decal-length-select");
    if (!wrap) return;

    wrap.addEventListener("click", (e) => {
      const row = e.target.closest("[data-dimensions-option]");
      if (!row) return;

      getDimensionsRows().forEach((btn) => {
        btn.classList.toggle("active", btn === row);
      });

      state.dimensions = row.dataset.value;
      syncDimensionsFallback(state.dimensions);
      toggleError("decal-length-error-bar", false);
      recalcPrice();
    });
  }

  function dropdownClickHandler(evt) {
    const dd = evt.target.closest(".select-dropdown");
    if (!dd) {
      document.querySelectorAll(".dropdown-options").forEach((ul) => hide(ul));
      return;
    }

    const menu = dd.querySelector(".dropdown-options");
    const header = dd.querySelector(".selected-text");
    const stateKey = dd.dataset.stateKey;
    const li = evt.target.closest("li[data-value]");

    document.querySelectorAll(".dropdown-options").forEach((ul) => {
      if (ul !== menu) hide(ul);
    });

    if (li) {
      menu.querySelectorAll("li").forEach((l) => l.classList.remove("selected"));
      li.classList.add("selected");
      header.textContent = li.textContent;
      dd.classList.add("variant-picked");

      if (stateKey === "font") {
        [...header.classList].forEach((cls) => {
          if (cls.startsWith("font-")) header.classList.remove(cls);
        });
        [...li.classList].forEach((cls) => {
          if (cls.startsWith("font-")) header.classList.add(cls);
        });
      }

      if (stateKey) state[stateKey] = li.dataset.value;
      hide(menu);
      recalcPrice();
      return;
    }

    menu.style.display = menu.style.display === "block" ? "none" : "block";
  }

  function handleColorSelection() {
    const list = getDecalColorList();
    const out = document.getElementById("selected-decal-color");
    if (!list || !out) return;

    list.addEventListener("click", (e) => {
      const sw = e.target.closest(".pcbd-letter-swatch, .sticker-variant");
      if (!sw || sw.classList.contains("active")) return;
      list
        .querySelector(".pcbd-letter-swatch.active, .sticker-variant.active")
        ?.classList.remove("active");
      sw.classList.add("active");
      out.textContent = sw.dataset.color;
      state.decal_color = sw.dataset.color;
    });
  }

  function handleRegNumberInput() {
    const inp = document.getElementById("username-input");
    const counter = document.getElementById("username-char-count");
    const error = document.getElementById("username-error-bar");
    const MAX = 13;
    if (!inp || !counter) return;

    inp.addEventListener("input", () => {
      if (inp.value.length > MAX) inp.value = inp.value.slice(0, MAX);
      state.reg_number = inp.value.toUpperCase();
      counter.textContent = `${MAX - inp.value.length} character(s) left`;
      hide(error);
    });
  }

  function toggleError(id, shouldShow) {
    const bar = document.getElementById(id);
    if (!bar) return;
    bar.style.display = shouldShow ? "block" : "none";
    bar.closest(".pcs-variant")?.classList.toggle("has-error", shouldShow);
  }

  function validateForm() {
    toggleError("font-error-bar", !state.font);
    toggleError("username-error-bar", !state.reg_number);
    toggleError("decal-length-error-bar", !state.dimensions);

    const firstBad = document.querySelector(".pcs-variant.has-error");
    if (firstBad) {
      firstBad.scrollIntoView({ behavior: "smooth", block: "center" });
      return false;
    }

    return true;
  }

  function resetCalculatorForm() {
    Object.assign(state, {
      color_fill: "Gradient Color Fill",
      font: "Anton",
      decal_color: "Gloss Black",
      reg_number: null,
      dimensions: '6" X 36" Inches',
      price: 39.48,
    });

    const cfWrap = document.getElementById("color-fill-variant");
    cfWrap?.querySelectorAll(".sticker-variant").forEach((el, i) => {
      el.classList.toggle("active", i === 0);
    });

    const swList = getDecalColorList();
    getDecalColorSwatches(swList).forEach((el, i) => {
      el.classList.toggle("active", i === 0);
    });

    const colorOut = document.getElementById("selected-decal-color");
    if (colorOut) colorOut.textContent = "Gloss Black";

    document.querySelectorAll(".select-dropdown").forEach((dd) => {
      const first = dd.querySelector("li.selected") || dd.querySelector("li[data-value]");
      if (!first) return;

      dd.querySelectorAll("li").forEach((li, i) => {
        li.classList.toggle("selected", li === first);
      });
      dd.querySelector(".selected-text").textContent = first.textContent;
      dd.classList.remove("variant-picked");

      const ul = dd.querySelector(".dropdown-options");
      if (ul) ul.style.display = "none";
    });

    const regInp = document.getElementById("username-input");
    if (regInp) regInp.value = "";

    const cnt = document.getElementById("username-char-count");
    if (cnt) cnt.textContent = "13 character(s) left";

    getDimensionsRows().forEach((el) => {
      el.classList.toggle("active", el.dataset.value === state.dimensions);
    });
    syncDimensionsFallback(state.dimensions);

    document.querySelectorAll(".error-bar").forEach((e) => {
      e.style.display = "none";
    });
    document.querySelectorAll(".pcs-variant").forEach((v) => {
      v.classList.remove("has-error");
    });

    recalcPrice();
  }

  function setupApippaAddToCart() {
    const addToCartBtn = document.getElementById("pcs-add-to-cart");
    if (!addToCartBtn || addToCartBtn.dataset.bound) return;
    addToCartBtn.dataset.bound = "true";

    addToCartBtn.addEventListener("click", async (e) => {
      e.preventDefault();

      if (!validateForm()) return;

      addToCartBtn.classList.remove("shine");
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add("loading");
      addToCartBtn.innerHTML = PCBD_CART_LOADING_HTML;

      try {
        const requestData = {
          calculatorId: "8054c1e0e7204",
          productId: 7693770260528,
          properties: {
            "Color Fill Option": state.color_fill,
            Font: state.font,
            "Decal Color": state.decal_color,
            "Registration Number": state.reg_number,
            "Decal Dimensions": state.dimensions,
          },
        };

        const res = await fetch("https://api.custompricecalculator.com/api/v1/variant", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        });
        const json = await res.json();
        const shopifyVariantId =
          typeof json === "string" ? json : json.variantId || json.id;
        if (!shopifyVariantId) throw new Error("Invalid variant ID");

        const fd = new FormData();
        fd.append("id", shopifyVariantId);
        fd.append("quantity", 1);
        Object.entries(requestData.properties).forEach(([k, v]) => {
          fd.append(`properties[${k}]`, v);
        });

        const cartAddRes = await fetch("/cart/add.js", { method: "POST", body: fd });
        const cartAddJson = await cartAddRes.json();
        if (!cartAddRes.ok) throw new Error("Failed to add to cart");

        const ts = Date.now();
        const html = await fetch(`/cart?section_id=mini-cart&t=${ts}`).then((r) =>
          r.text()
        );
        const tmp = document.createElement("div");
        tmp.innerHTML = html;
        const miniCartHTML = tmp.querySelector("cart-drawer")?.outerHTML;
        const cartDrawer = document.querySelector("cart-drawer");

        if (cartDrawer && miniCartHTML) {
          cartDrawer.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: { sections: { "mini-cart": miniCartHTML } },
                openMiniCart: true,
              },
            })
          );
        }

        setTimeout(() => {
          const lines = cartDrawer?.querySelectorAll("line-item") || [];
          lines.forEach((li) => {
            const priceCell =
              li.querySelector(".line-item__price-list-container .price") ||
              li.querySelector(
                ".product-item-meta__price-list-container .price-list.hidden-tablet-and-up .price"
              );
            if (!priceCell) return;
            if (!/Free|\$0\.00/.test(priceCell.textContent.trim())) return;

            let vid;
            const a = li.querySelector("a[href*='?variant=']");
            if (a && a.href.includes("variant=")) {
              vid = a.href.split("variant=")[1].split("&")[0];
            }
            if (!vid) {
              const rm = li.querySelector("a[href*='/cart/change?id=']");
              const m = rm?.getAttribute("href")?.match(/id=(\d+):/);
              vid = m?.[1];
            }
            if (vid != shopifyVariantId) return;

            const correct = (cartAddJson.price / 100).toFixed(2);
            priceCell.innerHTML = `<span class="visually-hidden">Sale price</span>$${correct}`;
          });
        }, 300);

        setTimeout(async () => {
          const c = await fetch("/cart.js").then((r) => r.json());
          const countEl = document.querySelector("cart-count");
          if (countEl) countEl.textContent = c.item_count;
        }, 300);

        setTimeout(() => {
          const drawerContent = document.querySelector(
            "#shopify-section-mini-cart .drawer__content"
          );
          if (!drawerContent) return;

          const confetti = document.createElement("dotlottie-player");
          confetti.className = "mini-cart-lottie";
          confetti.src =
            "//cdn.shopify.com/s/files/1/0582/5400/0176/files/confetti.json?v=1748024242";
          confetti.setAttribute("background", "transparent");
          confetti.setAttribute("speed", "1");
          confetti.style.width = "300px";
          confetti.style.height = "300px";
          confetti.setAttribute("autoplay", "");
          drawerContent.prepend(confetti);
          setTimeout(() => confetti.remove(), 3000);
        }, 1000);
      } catch (err) {
        console.error("Apippa Add to Cart Error:", err);
        alert("There was a problem adding your item to the cart.");
      } finally {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove("loading");
        addToCartBtn.innerHTML = PCBD_CART_BTN_HTML;
        resetCalculatorForm();
      }
    });
  }

  function playCartButtonShine() {
    const btn = document.getElementById("pcs-add-to-cart");
    if (!btn || btn.classList.contains("loading")) return;
    btn.classList.remove("shine");
    void btn.offsetWidth;
    btn.classList.add("shine");
  }

  function setupCartButtonShine() {
    const btn = document.getElementById("pcs-add-to-cart");
    if (!btn || btn.dataset.shineBound) return;
    btn.dataset.shineBound = "true";
    setTimeout(playCartButtonShine, 1500);
    setInterval(playCartButtonShine, 5000);
  }

  function init() {
    setupColorFillSelection();
    initDropdownDefaults();
    setupDecalSizeSelection();
    handleColorSelection();
    handleRegNumberInput();
    document.addEventListener("click", dropdownClickHandler);
    setupApippaAddToCart();
    setupCartButtonShine();
    recalcPrice();
  }

  init();
});
